// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1eiD3","notes":"Notes_notes__3INLT","note":"Notes_note__BdvON","markdown":"Notes_markdown__3urYJ"};